import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  usePlaybackState,
  usePlaybackSettings,
} from '../../../firebase/hooks/useVideoPlayback'
import usePlaybackStateUpdated from '../../hooks/usePlaybackStateUpdated'
import usePlaybackMetricsUpdated from '../../hooks/usePlaybackMetricsUpdated'
import { actionNames } from '../../shared/actions.playback'

/*
 * Single component, available only for the Producer, to include all hooks and logic related to playback
 */
const ProducerPlaybackControls = () => {
  const dispatch = useDispatch()
  const playbackSettings = usePlaybackSettings()
  const playbackState = usePlaybackState()
  const photoId = playbackState?.statePayload?.photoId

  usePlaybackStateUpdated()
  usePlaybackMetricsUpdated(photoId)

  useEffect(() => {
    if (playbackSettings === null) {
      return
    }

    if (playbackSettings.shouldLoop) {
      dispatch({ type: actionNames.ENABLE_LOOPING })
    } else {
      dispatch({ type: actionNames.DISABLE_LOOPING })
    }
  }, [playbackSettings, dispatch])

  return null
}

export default ProducerPlaybackControls
